import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import nds from '@nerdwallet/base-styles/classes';

import { Text, Heading } from '@nerdwallet/react-typography';
import Row from '../row/row';
import SmartButton from '../smart-button/smart-button';

import parseMarkdownLinks from '../../lib/parse-md-links';

import {
  stringTextAreaSpec,
  stringInputSpec,
  stringSelectSpec,
} from '../../lib/editing-configs';

import './cta-box.less';

const CtaBox = ({
  title,
  body,
  iconUri,

  // For the button
  buttonType,
  buttonText,
  buttonURL,
  buttonParams,
  headingStyle,
  successURL,
  authDialogCopyOverrides,
  authDialogImageOverrides,
  appStoreURL,
  googlePlayURL,
}) => (
  <Row
    centeredInParent
    standardMaxWidths
    className={classNames([
      nds('margin-vertical-4'),
      nds('padding-top-4'),
      nds('padding-bottom-3'),
      nds('padding-horizontal-3'),
      nds('border-all-1'),
      nds('border-neutral-lighter'),
      nds('display-flex--wide'),
      // account for icon spacing when not mobile
      {
        [nds('padding-right-3--wide')]: iconUri,
        [nds('padding-left-0--wide')]: iconUri,
      },
      'cta-box',
    ])}
  >
    {iconUri ? (
      <Row
        backgroundImage={iconUri}
        className={classNames([
          nds('display-none'),
          nds('display-block--wide'),
          'cta-box__icon',
        ])}
      />
    ) : null}
    <Row className="cta-box__text">
      <Heading level={headingStyle}>{title}</Heading>
      <Text className={nds('padding-vertical-2')}>
        {parseMarkdownLinks(body)}
      </Text>
    </Row>
    {buttonType ? (
      <Row className="cta-box__cta">
        <Row className={nds('display-none--wide')}>
          <SmartButton
            buttonText={`${buttonText} >`}
            buttonURL={buttonURL}
            buttonType={buttonType}
            buttonParams={buttonParams}
            successURL={successURL}
            authDialogCopyOverrides={authDialogCopyOverrides}
            authDialogImageOverrides={authDialogImageOverrides}
            appStoreURL={appStoreURL}
            googlePlayURL={googlePlayURL}
            link
          />
        </Row>
        <Row
          className={nds(
            'display-none',
            'display-block--wide',
            'margin-horizontal-3'
          )}
        >
          <SmartButton
            buttonText={buttonText}
            buttonURL={buttonURL}
            buttonType={buttonType}
            buttonParams={buttonParams}
            appStoreURL={appStoreURL}
            googlePlayURL={googlePlayURL}
          />
        </Row>
      </Row>
    ) : null}
  </Row>
);

CtaBox.propTypes = {
  headingStyle: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  iconUri: PropTypes.string,
  ...SmartButton.propTypes,
};

CtaBox.defaultProps = {
  headingStyle: '3',
};

CtaBox.displayName = 'CtaBox';

CtaBox.getEditingConfig = (componentDocument) => [
  stringTextAreaSpec('title', 'Title'),
  stringSelectSpec('headingStyle', 'Heading Style', [
    { label: 'Select one', value: '' },
    { label: 'Heading 1', value: '1' },
    { label: 'Heading 2', value: '2' },
    { label: 'Heading 3', value: '3' },
    { label: 'Heading 4', value: '4' },
    { label: 'Heading 5', value: '5' },
  ]),
  stringTextAreaSpec('body', 'Body', {
    help: `Want a hyperlink? Write it like this: [Hi!](https://www.thing.com).
           NW links should be relative, e.g., [Home](/home)`,
  }),
  stringInputSpec('iconUri', 'Icon URL'),
  ...SmartButton.getEditingConfig(componentDocument),
];

export default CtaBox;
